import * as React from 'react';
const classNames = require('classnames');

import { IconBlock, IconCheckCircle } from '../components/icons';

interface Props {
	className?: string;
	children?: {};
	items?: Array<any>;
}

const QuotePlanDetails: React.StatelessComponent<Props> = ({ className, children, items }) => {
	return (
		<div className={classNames('quote-plan-details', className)}>
			<small className="d-block">
				<strong>Coverage amount could support:</strong>
			</small>
			{items && <ul className="mt-3 mb-0 list-unstyled">
				{items.map((item, index) => (
					<li className="media" key={index}>
						{item.enabled ? <IconCheckCircle className="text-secondary" /> : <IconBlock className="disabled" />}
						<div className="ml-2 media-body align-self-center">
							{item.description}
						</div>
					</li>
				))}
			</ul>}
			{children}
		</div>
	);
};

export default QuotePlanDetails;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/QuotePlanDetails.tsx